import { accessors, constants } from '@yola/subscription-manager-js';

const {
  hostingPackageFeatureNames: { AI_BLOCK_GENERATION_QUOTA },
} = constants;

const UNLIMITED = 'unlimited';
const MAX_GENERATION_UNLIMITED_PLACEHOLDER = 100000;

const getAmountFromLimit = (limit) =>
  limit === UNLIMITED ? MAX_GENERATION_UNLIMITED_PLACEHOLDER : limit;

const aiBlockGenerationLimit = ({ targetPackage }) => {
  const topPackage = accessors.getTopAvailableHostingPackage();
  const topPackageAmount = getAmountFromLimit(topPackage.features[AI_BLOCK_GENERATION_QUOTA]);
  const targetPackageAmount = getAmountFromLimit(targetPackage.features[AI_BLOCK_GENERATION_QUOTA]);

  return {
    amount: targetPackageAmount,
    upgradeAvailable: topPackageAmount > targetPackageAmount,
  };
};

export default aiBlockGenerationLimit;
